<template>
    <Fragment>
        <v-list class="mx-2" v-if="items.length > 0">
            <v-list-group v-for="item in items" :key="item.rk_guid" class="pb-2">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title class="d-flex">
                            Заказ № {{ item.id }}
                            <v-spacer/>
                            {{ item.rk_payment_sum }} Р
                        </v-list-item-title>
                        <v-list-item-subtitle class="d-flex">
                            {{ formateDate(item.deliver_at) }}
                            <v-spacer/>
                            <span :class="`${statuses[item.status].color}--text`">{{ formateStatus(item.status) }}</span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </template>
                <v-list-item test-tag="tag-54" style="width: 100%;">
                    <v-row dense align="center">
                        <v-col cols="7">
                            <v-list-item-content v-for="(session, idx) in item.sessions" :key="`session-${idx}`">
                                <table key="order">
                                    <tr v-for="item in session.content.items" :key="item.line_guid">
                                    <td style="font-size: 1.12em;">
                                        {{  menu_items_map[item.id] ?  menu_items_map[item.id].name : `Блюдо c идентификатором ${item.id} сейчас не доступно`}}
                                        <div class="text-caption ml-3" v-for="modifier, n in item.modifiers" :key="n">
                                        x{{modifier.quantity}} {{menu_modifier_schemes_map[modifier] ? modifier.name : `Модификатор c идентификатором ${item.id} сейчас не доступно` }}
                                        </div>
                                    </td>
                                    <td style="text-align: end; vertical-align: top">x{{ item.quantity }}</td>
                                    <!-- <td style="text-align: end; vertical-align: top">={{ (item.sum).toFixed(2) }}</td> -->
                                    </tr>
                                </table>
                            </v-list-item-content>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="4" v-if="$route.path === '/orders/new'">
                            <v-btn test-tag="tag-53" color="primary" @click="repeatOrder(item)"><v-icon>mdi-restore</v-icon>Повторить</v-btn>
                        </v-col>
                    </v-row>
                </v-list-item>
            </v-list-group>
        </v-list>
        <div v-else class="d-flex justify-center align-center fill-height" style="height: 500px;">
            <div class="text-center">
                <v-icon x-large style="transform: scale(2)">mdi-clipboard-off-outline</v-icon>
                <h3 class="mt-5"><T>История заказов пуста.</T></h3>
            </div>
        </div>
        <v-card v-intersect="infiniteScrolling"></v-card>
    </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { mapActions, mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import { eventBus } from '@/main';

import { order_statuses } from '../../../helpers/status_helper.js'

export default{
    props: ['value'],
    data: () =>({
        items: [],
        page: 0,
        is_end: false
    }),
    computed: {
        ...mapGetters(['menu_items_map', 'menu_modifier_schemes_map', 'orderItems']),
        statuses(){
            return order_statuses
        }
    },
    methods:{
        ...mapActions(['getGuestHistory', 'pushItem', 'throwTimeoutMessage']),
        formateDate(date){
            return DateTime.fromISO(date).toFormat('dd.LL.yy HH:MM')
        },
        formateStatus(status){
            switch(status){
                case 'ARCHIVED':
                    return this.$t('Доставлен')
                case 'DELAYED':
                    return this.$t('Предзаказ')
                case 'COOKING':
                    return this.$t('Готовится')
                case 'DELIVERING':
                    return this.$t('В пути')
                case 'WAIT_CONFIRM':
                    return this.$t('Подтвердить')
                case 'WAIT_PAY':
                    return this.$t('Оплатить')
                case 'CANCELED':
                    return this.$t('Отменён')
            }
        },
        async infiniteScrolling(){
            if(!this.is_end) {
                this.page++
                const result = await this.getGuestHistory({
                    guest_id: this.value.id,
                    page: this.page,
                    itemsPerPage: 10
                })
                this.items = [...this.items, ...result.items]
                this.is_end = result.is_end
            }
        },
        repeatOrder(item){
            if(this.orderItems && Object.keys(this.orderItems).length) this.$store.commit('dropItems')

            item.sessions.forEach(session => {
                session.content.items.forEach(dish => {
                    if(!this.menu_items_map[dish.id]) return;
                    
                    // const new_dish = {
                    //     line_guid: dish.line_guid,
                    //     modifiers: dish.modifiers,
                    //     product:  this.menu_items_map[dish.id],
                    //     quantity: dish.quantity
                    // }
                    // this.$store.commit('setItems', new_dish)
                    this.pushItem({
                        modifiers: dish.modifiers,
                        product:  this.menu_items_map[dish.id],
                        quantity: dish.quantity
                    })
                })
            })

            this.throwTimeoutMessage({
                message_data: 'Повтор заказа выполнен',
                message_class: 'success'
            })

            eventBus.$emit('addItems')
        
        }
    },
    async mounted(){
        await this.infiniteScrolling()
    },
    components:{
        Fragment,
    }
}
</script>